import { Skeleton, cn } from "@ibada/ui"

/** Bar-chart silhouette skeleton: a row of varied-height bars + a sparse axis line. Reduced-motion aware. */
export function DashboardChartSkeleton({
  height = 168,
  variant = "bars",
  className,
}: {
  height?: number
  variant?: "bars" | "area"
  className?: string
}) {
  const heights = [52, 74, 40, 88, 60, 96, 46, 80]
  return (
    <div className={cn("w-full", className)} style={{ height }} aria-hidden="true">
      {variant === "bars" ? (
        <div className="flex h-[calc(100%-16px)] items-end gap-2">
          {heights.map((h, index) => (
            <Skeleton
              key={index}
              className="flex-1 rounded-sm motion-reduce:animate-none"
              style={{ height: `${h}%` }}
            />
          ))}
        </div>
      ) : (
        <Skeleton
          className="h-[calc(100%-16px)] w-full rounded-md [clip-path:polygon(0_70%,15%_55%,30%_62%,45%_40%,60%_48%,75%_28%,90%_38%,100%_25%,100%_100%,0_100%)] motion-reduce:animate-none"
        />
      )}
      <div className="mt-2 flex justify-between">
        <Skeleton className="h-2 w-8 motion-reduce:animate-none" />
        <Skeleton className="h-2 w-8 motion-reduce:animate-none" />
        <Skeleton className="h-2 w-8 motion-reduce:animate-none" />
      </div>
    </div>
  )
}

export function DashboardChartEmptyState({ message, height = 168 }: { message: string; height?: number }) {
  return (
    <div
      className="flex w-full items-center justify-center rounded-md border border-dashed border-border/70 text-center text-xs text-muted-foreground"
      style={{ height }}
    >
      {message}
    </div>
  )
}
